<template>
  <v-form v-if="!loading" class="ma-2" ref="form" v-model="valid" lazy-validation>
    <v-card>
      <v-card-title>{{identity.profile.name}} / {{identity.profile.description}}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <v-card>
              <v-row>
                <v-col cols="12">
                  <v-card-title>
                    <div class="headline">Start</div>
                  </v-card-title>
                </v-col>
                <v-col class="pl-4" cols="8">
                  <v-menu v-model="startDateMenu" :close-on-content-click="false" max-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedStartDateFormatted"
                        label="Date"
                        clearable
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        @blur="checkDateTime()"
                        :disabled="groupEditChoice == 1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :locale="$moment.locale()"
                      v-model="startDate"
                      no-title
                      @change="startDateMenu = false"
                      :disabled="groupEditChoice == 1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="pr-4" cols="4" v-if="!documentsExist">
                  <v-menu
                    ref="starttimemenu"
                    v-model="startTimeMenu"
                    :close-on-content-click="false"
                    :return-value.sync="startTime"
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startTime"
                        label="Time"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                        @change="checkDateTime()"
                        :disabled="groupEditChoice == 1"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      format="24hr"
                      v-if="startTimeMenu"
                      v-model="startTime"
                      @click:minute="$refs.starttimemenu.save(startTime)"
                      :disabled="groupEditChoice == 1"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card>
              <v-row>
                <v-col cols="12">
                  <v-card-title>
                    <div class="headline">End</div>
                  </v-card-title>
                </v-col>
                <v-col class="pl-4" cols="8">
                  <v-menu v-model="endDateMenu" :close-on-content-click="false" max-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedEndDateFormatted"
                        label="Date"
                        clearable
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        @blur="checkDateTime()"
                        :disabled="groupEditChoice == 1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :locale="$moment.locale()"
                      v-model="endDate"
                      :min="startDate"
                      no-title
                      @change="endDateMenu = false"
                      :disabled="groupEditChoice == 1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="pr-4" cols="4" v-if="!documentsExist">
                  <v-menu
                    ref="endtimemenu"
                    v-model="endTimeMenu"
                    :close-on-content-click="false"
                    :return-value.sync="endTime"
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="endTime"
                        label="Time"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                        @change="checkDateTime()"
                        :disabled="groupEditChoice == 1"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      format="24hr"
                      v-if="endTimeMenu"
                      v-model="endTime"
                      @click:minute="$refs.endtimemenu.save(endTime)"
                      :disabled="groupEditChoice == 1"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" v-if="getNote() != null && getNote() != ''">
            <template>
              <v-container>
                <v-card>
                  <div class="pa-2">
                    <v-icon large color="error" class="float-left mr-2">mdi-checkbox-marked</v-icon><p class="body-2 pa-2">Opmerking:</p>
                  </div>
                  <v-col cols="10">
                    <v-sheet color="grey lighten-3" class="pa-2" elevation="3">{{getNote()}}</v-sheet>
                  </v-col>
                </v-card>
              </v-container>
            </template>
          </v-col>
          <v-col cols="12" v-for="step in identity.profile.steps" :key="step.id">
            <v-card xs12 class="mx-auto" v-if="showStepDocuments(step)">
              <v-card-title primary-title>
                <div>{{step.name}}</div>
              </v-card-title>
              <v-card-text v-if="step.description">
                <span class="grey--text subtitle-1">{{step.description}}</span>
              </v-card-text>
              <v-container class="pt-0 mt-0" fluid>
                <v-row>
                  <v-col cols="12">
                    <div class="mb-2" v-for="field in step.fields" :key="field.id">
                      <div
                        v-if="groupEditChoice == 0 || (!field.isGroupField && groupEditChoice == 1) || (field.isGroupField  && groupEditChoice == 2)"
                      >
                        <v-tooltip
                          top
                          v-if="field.type != 40 && field.type != 37 && field.type != 20 && field.type != 21 && field.type != 1 && field.type != 2 && field.type != 3 && field.type != 5 && field.type != 38"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-on="field.description && on"
                              v-model="field.value"
                              v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                              :required="field.isRequired"
                              :rules="getRule(field.type, field.isRequired)"
                              autocomplete="off"
                            ></v-text-field>
                          </template>
                          <span>{{field.description}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="field.type == 1">
                          <template v-slot:activator="{ on }">
                            <v-textarea
                              v-on="field.description && on"
                              v-model="field.value"
                              :required="field.isRequired"
                              v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                              autocomplete="off"
                            ></v-textarea>
                          </template>
                          <span>{{field.description}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="field.type == 2">
                          <template v-slot:activator="{ on }">
                            <v-switch
                              v-on="field.description && on"
                              v-model="field.value"
                              :required="field.isRequired"
                              v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                              @click="condition(field)"
                              :disabled="field.isReadOnly"
                            ></v-switch>
                          </template>
                          <span>{{field.description}}</span>
                        </v-tooltip>

                        <v-tooltip top v-if="field.type == 3 && fieldsDates">
                          <template v-slot:activator="{ onTooltip }">
                                <v-menu
                                  v-model="fieldsDates.find(f => f.id == field.id).datemenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  v-on="onTooltip"
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      :value="computedStartDateFormatted"
                                      v-model="fieldsDates.find(f => f.id == field.id).dateFormatted"
                                      :required="field.value && field.value != ''"
                                      :rules="getRule(field.type, (field.value && field.value != ''))"
                                      v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                      prepend-icon="event"
                                      @blur="fieldsDates.find(f => f.id == field.id).date=parseDate(fieldsDates.find(f => f.id == field.id).dateFormatted)"
                                      v-on="on"
                                      autocomplete="off"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    :locale="$moment.locale()"
                                    v-model="fieldsDates.find(f => f.id == field.id).date"
                                    no-title
                                    @input="fieldsDatePicker(field.id)"
                                  ></v-date-picker>
                                </v-menu>
                              </template>
                          <span>{{field.description}}</span>
                        </v-tooltip>

                        <v-tooltip top v-if="field.type == 5">
                          <template v-slot:activator="{ on }">
                            <v-autocomplete
                              v-on="field.description && on"
                              :items="field.items"
                              item-text="name"
                              item-value="value"
                              :rules="autoRules"
                              v-model="field.value"
                              v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                              @change="condition(field)"
                            ></v-autocomplete>
                          </template>
                          <span>{{field.description}}</span>
                        </v-tooltip>

                        <v-tooltip top v-if="field.type == 20">
                          <template v-slot:activator="{ on }">
                            <v-autocomplete
                              v-on="field.description && on"
                              :items="sexes"
                              item-text="name"
                              item-value="value"
                              :rules="autoRules"
                              v-model="field.value"
                              v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                              @change="condition(field)"
                            ></v-autocomplete>
                          </template>
                          <span>{{field.description}}</span>
                        </v-tooltip>

                        <v-tooltip top v-if="field.type == 38 && showStepDocumentsField(field) && documentsList && documentsDates">
                          <template v-slot:activator="{ on }">
                            <v-row>
                              <v-col cols="8" class="pt-6" v-if="!field.value">
                                <v-btn small v-on="on" @click="openFileDialog(field)">
                                  Upload {{getDocumentTypeNameById(field.name)}}
                                  <v-icon right dark> cloud_upload</v-icon>
                                </v-btn>
                                <input type="file" :id="field.id" style="display:none" @change="onFileChange">
                                <v-btn v-if="documentsList.find(x => x.type.id == field.name).type.description != null"
                                  @click="downloadDoc(documentsList.find(x => x.type.id == field.name).type.description)"
                                  small class="ml-2" text color="primary">Download template</v-btn>
                              </v-col>
                              <v-col cols="8" class="pt-6" v-else>
                                  <v-btn small v-bind:color="getValidationColor(field)" v-on="on" @click="downloadFile(field.value, getDocumentTypeNameById(field.name))">
                                    {{getDocumentTypeNameById(field.name)}}
                                    <v-icon right dark>check</v-icon>
                                  </v-btn>
                                  <v-btn small class="ml-2" color="error" @click.stop="documentsDates.find(x => x.id == field.id).deleteDialog = true">
                                    <v-icon dark>delete</v-icon>
                                  </v-btn>
                                  <v-dialog
                                    v-model="documentsDates.find(x => x.id == field.id).deleteDialog"
                                    max-width="290">
                                  <v-card>
                                    <v-card-title class="subtitle-2">Weet u zeker dat u wilt verwijderen? /<br />Are you sure you want to delete?</v-card-title>
                                      <v-divider></v-divider>
                                      <br />
                                      <v-card-text>
                                        <v-btn class="float-right" @click="documentsDates.find(x => x.id == field.id).deleteDialog = false">cancel</v-btn>
                                        <v-btn color="primary" @click="deleteFile(field)">ok</v-btn>
                                      </v-card-text>
                                  </v-card>
                                </v-dialog>
                              </v-col>
                              <v-col cols="4" v-if="documentsList.find(x => x.type.id == field.name).type.expirationDateRequired">
                                <template>
                                  <v-menu
                                    v-model="documentsDates.find(x => x.id == field.id).datemenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        :value="computedStartDateFormatted"
                                        v-model="documentsDates.find(x => x.id == field.id).dateFormatted"
                                        :required="field.value && field.value != ''"
                                        :rules="getRule(field.type, (field.value && field.value != ''))"
                                        v-bind:label="'Vervaldatum' + (field.value && field.value != '' ? ' *': '')"
                                        prepend-icon="event"
                                        @blur="documentsDates.find(x => x.id == field.id).date = parseDate(documentsDates.find(x => x.id == field.id).dateFormatted)"
                                        v-on="on"
                                        autocomplete="off"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      :locale="$moment.locale()"
                                      v-model="documentsDates.find(x => x.id == field.id).date"
                                      no-title
                                      @input="documentsDatePicker(field.id)"
                                    ></v-date-picker>
                                  </v-menu>
                                </template>
                              </v-col>
                            </v-row>
                          </template>
                          <span>{{field.description}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="field.type == 37">
                          <template v-slot:activator="{ on }">
                            <v-autocomplete
                              v-on="field.description && on"
                              :items="filterOrganizations(field.name)"
                              item-text="name"
                              item-value="id"
                              v-model="field.value"
                              :label="getOrganizationProfileName(field.name)"
                            ></v-autocomplete>
                          </template>
                          <span>{{field.description}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="field.type == 21" >
                          <template v-slot:activator="{ onTooltip }">
                            <v-menu
                              ref="datemenu"
                              v-model="datemenu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              v-on="onTooltip"
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="dateFormatted"
                                  v-bind:label="(field.name + (field.isRequired ? ' *': ''))"
                                  hint="DD-MM-YYYY"
                                  persistent-hint
                                  prepend-icon="event"
                                  @blur="date=parseDate(dateFormatted)"
                                  v-on="on"
                                  autocomplete="off"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                :locale="$moment.locale()"
                                ref="datemenuPicker"
                                v-model="date"
                                no-title
                                min="1930-01-01"
                                @input="datemenu = false"
                              ></v-date-picker>
                            </v-menu>
                          </template>
                          <span>{{field.name}}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-btn class="ma-2 float-right" @click="back">annuleer / cancel</v-btn>
            <v-btn
              v-if="documentsExist && documentsStep == 1"
              class="ma-2"
              color="success"
              @click="documentsStep--"
            >terug / back</v-btn>

            <v-btn
              v-if="!documentsExist || (documentsExist && documentsStep == 1)"
              class="ma-2"
              color="success"
              @click="submit(false)"
              :disabled="!valid"
            >opslaan / submit</v-btn>
            <v-btn
              v-else
              class="ma-2"
              color="success"
              @click="nextStep"
              :disabled="!valid"
            >volgende / next</v-btn>

            <br />
            <v-btn
              v-if="groupEditChoice != 2 && identity.profile.enableGroups"
              class="ma-2"
              color="success"
              @click="submit(true)"
              :disabled="!valid"
            >opslaan als groep en voeg nieuwe toe / submit as group and add new</v-btn>
            <span>{{submitStatus}}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
export default {
  props: ["identity", "me", "groupEditChoice"],
  data: () => ({
    loading: true,
    submitStatus: null,
    hiddenFields: [],
    startTime: "09:00",
    startDate: new Date().toISOString().substr(0, 10),
    startDateMenu: false,
    startTimeMenu: false,
    endTime: null,
    endDate: null,
    endDateMenu: false,
    endTimeMenu: false,
    organizationProfiles: [],
    organizations: [],
    valid: false,
    nameRules: [
      v => !!v || "This field is required",
      v => (v && v.length <= 100) || "100 characters maximum"
    ],
    emailRules: [
      v => !!v || "This field is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    emailOptionalRules: [
      v => {
        if (v && v.length > 0) {
          const pattern = /.+@.+\..+/;
          return pattern.test(v) || "E-mail must be valid";
        } else return true;
      }
    ],
    numberOptionalRules: [
      v => {
        if (v && v.length > 0) {
          const pattern = /^-?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/;
          return pattern.test(v) || "Only numbers are allowed";
        } else return true;
      }
    ],
    autoRules: [v => !!v || "This field is required"],
    datemenu: false,
    date: null,
    dateFormatted: "",
    fieldsDates: null,
    documentTypes: [],
    documentsExist: false,
    documentsStep: 0,
    documentsFilters: null,
    documentsList: null,
    documentsDates: null,
    documentsSelected: [],
    uploadField: null,
    sexes: [
        {value: 0, name:'Onbekend / Unknown' },
        {value: 1, name:'Man / Male' },
        {value: 2, name:'Vrouw / Female' },
        {value: 3, name:'Niet vastgesteld / Unspecified' }
      ],
  }),
  watch: {
    startDate() {
      if (this.startDate > this.endDate) {
        this.endDate = null;
      }
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    datemenu(val) {
      val &&
        this.date == null &&
        setTimeout(
          () => (
            (this.$refs.datemenuPicker[0].activePicker = "YEAR"),
            (this.date =
              new Date(
                new Date().setFullYear(new Date().getFullYear() - 12)
              ).getFullYear() + "-01-01")
          )
        );
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedStartDateFormatted() {
      return this.startDate
        ? this.$moment.utc(this.startDate).format("ddd D MMM YYYY")
        : "";
    },
    computedEndDateFormatted() {
      return this.endDate
        ? this.$moment.utc(this.endDate).format("ddd D MMM YYYY")
        : "";
    },
    resultStartDateTime() {
      var dateTimeString = this.startDate;
      if (this.startTime != null && this.startTime.length === 5)
        dateTimeString += "T" + this.startTime;
      return this.$moment(dateTimeString).toISOString();
    },
    resultEndDateTime() {
      var dateTimeString = this.endDate;
      if (this.endTime != null && this.endTime.length === 5)
        dateTimeString += "T" + this.endTime;
      return this.$moment(dateTimeString).toISOString();
    }
  },
  methods: {
    condition(field) {
      if (field && field.settings && field.settings.length > 0) {
        var val = JSON.parse(field.settings);
        if (val.conditions && val.conditions.length > 0) {
          this.identity.profile.steps.forEach(step => {
            step.fields.forEach(stepField => {
              val.conditions.forEach(v => {
                if (stepField.name === v.target) {
                  stepField.isReadOnly = false;
                  if (field.value === v.condition) {
                    if (v.valid.value != "*") stepField.value = v.valid.value;
                      stepField.isReadOnly = v.valid.disabled;
                  } else {
                    if (v.not.value != "*") stepField.value = v.not.value;
                      stepField.isReadOnly = v.not.disabled;
                  }
                }
              })
            });
          });
        }
      }
    },
    setSelection() {
      this.documentsFilters = [];
      this.identity.profile.steps.forEach(step => {
        step.fields.forEach(stepField => {
          if (stepField.settings && stepField.settings.length > 0) {
            var val = JSON.parse(stepField.settings);
            if (val.conditions) {
              if (stepField.value == "false" || stepField.value == "") 
                stepField.value = false;
              else if (stepField.value == "true")
                stepField.value = true;
              this.documentsFilters.push({ "name": stepField.name, "value": stepField.value });
            }
          }
        });
      });
    },
    showStepDocuments(step) {
      var docs = false;
      if (this.me.person.isEditor && step.isValidationStep)
        return false;
      step.fields.forEach(stepField => {
        if (stepField.type == 38) docs = true;
      });
      if (this.documentsExist) {
        if (this.documentsStep == 0) return !docs;
          else return docs;
      } else return true;
    },
    showStepDocumentsField(field) {
      var show = true;
      if (this.documentsFilters && this.documentsFilters.length > 0) {
        var subtotal = this.documentsFilters.length;
        if (field.settings && field.settings.length > 0) {
          var val = JSON.parse(field.settings);
          if (val.filters && val.filters.length > 0) {           
            show = false;
            var score = 0;
            val.filters.forEach(filter => {
              var subscore = 0;
              filter.forEach(set => {
                this.documentsFilters.forEach(selection => {
                  if (set.name == selection.name) {
                    if (set.value == "*" || set.value == selection.value ||
                      (set.value.toString().substring(0,1) == "!" && set.value.substring(1) != selection.value))
                      subscore++;
                  }
                });
              });
              if (subscore == subtotal)
                score++;
            });
            if (score > 0)
              show = true;
          }
        }
      }
      return show
    },
    nextStep() {
      if (!this.$refs.form.validate()) {
        this.submitStatus = "ERROR";
      } else {
        this.setSelection();
        this.submit(false);
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    checkDateTime() {
      var futureDate = false;
      if (this.startDate && this.endDate == null) this.endDate = this.startDate;
      else if (this.startDate && this.endDate) {
        if (this.endDate > this.startDate) futureDate = true;
        else this.endDate = this.startDate;
      }
      if (this.startTime && this.endTime == null) this.endTime = this.startTime;
      else if (this.startTime && this.endTime) {
        if (this.startTime > this.endTime && !futureDate)
          this.endTime = this.startTime;
      }
    },
    getFieldItemName(item) {
      return item.name + " (" + item.value + ")";
    },
    getOrganizationProfileName(id) {
      return this.organizationProfiles.find(x => x.id == id).name;
    },
    setBirthDate() {
      this.identity.profile.steps.forEach(step => {
        step.fields.forEach(stepField => {
          if (stepField.type == 21) {
            this.date = stepField.value;
          }
        });
      });
    },
    submit(copy) {
      this.$parent.loading = true;
      this.documentsSelected = [];
      if (!this.$refs.form.validate()) {
        this.submitStatus = "ERROR";
        this.$parent.loading = false;
      } else {
        this.submitStatus = "POSTING";
        this.identity.profile.steps.forEach(step => {
          step.fields.forEach(stepField => {
            if (stepField.type == 21 && this.date != null) {
              stepField.value = this.date;
            }  else if (stepField.type == 3 && this.documentsStep == 2) {
                var fieldDate = this.fieldsDates.find(d => d.id == stepField.id).date;
                stepField.value = fieldDate ? fieldDate : '';
            }
            else if (stepField.type == 38) {
              var docDate = this.documentsDates.find(x => x.id == stepField.id).date;
              this.documentsList.find(x => x.type.id == stepField.name).expirationDate = docDate ? docDate : '';
              if (this.showStepDocumentsField(stepField)) {
                  this.documentsSelected.push(this.documentsList.find(x => x.type.id == stepField.name));
              }
            }
          });
        });
        this.identity.startDate = this.resultStartDateTime;
        this.identity.endDate = this.resultEndDateTime;
        this.identity.status = this.statusNameToId('Announced');
        if (
          this.identity.id == null ||
          this.identity.id == "" ||
          this.identity.id == "00000000-0000-0000-0000-000000000000"
        ) {
          delete this.identity.id;
          this.identity.status = this.statusNameToId('Created');
        }
        if (copy && !this.identity.groupProfileId)
          this.identity.groupProfileId = "00000000-0000-0000-0000-000000000000";
        
        var saveGroup = false;
        if (!this.documentsExist) {
          if (copy || this.groupEditChoice == 2 ||
            (!copy && this.identity.groupProfileId != "00000000-0000-0000-0000-000000000000")) {
              saveGroup = true;
          }
        }
        let indentityView = { 
          identity: this.identity, 
          documents: this.documentsSelected, 
          saveGroup: saveGroup };
        this.$http
          .post("api/identities/", indentityView)
          .then(request => {
            if (request.status == 201) {
              this.submitStatus = "";
              this.endSubmit(copy, request.data);
            } else {
              this.submitStatus = "ERROR";
              this.$parent.loading = false;
            }
          })
          .catch(e => {
            this.$root.$children[0].$emit("display-error", "1400", e);
            this.submitStatus = "ERROR";
            this.$parent.loading = false;
          });
      }
    },
    endSubmit(copy, data) {
      if (!copy) {
        this.processorResult = data;
        if (this.documentsExist && data.message == "IdentityId" && this.documentsStep == 0) {
          this.documentsStep = 1;
          this.identity.id = data.data;
          this.$parent.loading = false;
        } else
          this.$emit("done");
      } else {
        this.$parent.groupEditChoice = 1;
        this.identity.id = null;
        this.identity.profile.steps.forEach(s => {
          s.fields.forEach(f => {
            if (!f.isGroupField) {
              f.value = "";
            }
          });
        });
        this.setBirthDate();
        this.$parent.processorResult = data;
      }
    },
    back() {
      this.$emit("done");
    },
    getOrganizationProfiles() {
      this.$http
        .get("api/organizationprofiles/")
        .then(request => {
          this.organizationProfiles = request.data;
          this.loading = false;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1401", e);
        });
    },
    filterOrganizations(profileId) {
      return this.organizations.filter(x => x.profileId == profileId);
    },
    getOrganizations() {
      this.$http
        .get("api/organizations/")
        .then(request => {
          this.organizations = request.data;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1402", e);
        });
    },
    getDocumentTypes() {
      this.$http
        .get("api/documenttypes/")
        .then(request => {
          if (request.status == 200) {
            this.documentTypes = request.data;
            this.analyseProfile();
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1403", e);
        });
    },
    onFileChange(e) {
      this.newFileForm = new FormData();
      var files = e.target.files || e.dataTransfer.files;
      if(files.length > 0){
        if (files[0].type != "application/pdf") {
          alert("Alleen pdf files zijn toegestaan / Only Pdf files are allowed");
          return;
        }
        if (files[0].size > 10485760) {
          alert("Alleen files tot 10 Mb toegestaan / Only files up to 10Mb allowed");
          return;
        }
        this.newFileName = files[0].name;
        this.newFileForm.append("file", files[0], files[0].name);
      }
      if(e) {
        this.$http
          .post("api/appfile/", this.newFileForm, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(request => {
            if (request.status == 201) {
              if (!this.uploadField) this.$root.$children[0].$emit("display-error", "1404", "no file upload initialized");
              var uploadStep = this.identity.profile.steps.find(s => s.id === this.uploadField.stepId);
              if (!uploadStep) this.$root.$children[0].$emit("display-error", "1405", "no step found");
              var uploadField = uploadStep.fields.find(f => f.id === this.uploadField.id);
              if (!uploadField) this.$root.$children[0].$emit("display-error", "1406", "no field found");
              uploadField.value = request.data;
            }
          })
          .catch(err => {
          this.$root.$children[0].$emit("display-error", "1407", err);
          });
      } else {
        this.$root.$children[0].$emit("display-error", "1408", "no file selected");
      }
    },
    getValidationColor(field){
      if ((this.documentsList && 
        this.documentsList.find(d => d.type.id == field.name)) && (
        (this.documentsList.find(d => d.type.id == field.name).isValidated != null &&
        this.documentsList.find(d => d.type.id == field.name).isValidated == true) ||
        this.documentsList.find(d => d.type.id == field.name).type.validationRequired == false))
        return 'success';
      else if ((this.documentsList && 
        this.documentsList.find(d => d.type.id == field.name)) && (
        (this.documentsList.find(d => d.type.id == field.name).isValidated != null &&
        this.documentsList.find(d => d.type.id == field.name).isValidated == false)))
        return 'error';
      else
        return 'warning';
    },
    getDocumentTypeNameById(id) {
      var result = '';
      if (this.documentTypes) result = this.documentTypes.find(x => x.id === id).name;
      return result;
    },
    openFileDialog(field) {
      this.uploadField = field;
      document.getElementById(field.id).click();
    },
    deleteFile(field) {
      if (this.documentsDates && this.documentsList) {
        field.value = null;
        this.documentsDates.find(d => d.id == field.id).date = null;
        this.documentsDates.find(d => d.id == field.id).dateFormatted = '';
        this.documentsList.find(d => d.type.id == field.name).isValidated = null;
        this.documentsDates.find(x => x.id == field.id).deleteDialog = false;
      }
      this.uploadField = null;
    },
    downloadFile(id, filename) {
      this.$http
        .get("api/appfile/" + id)
        .then(request => {
          if (request.status == 200) {
            var blob = this.base64toBlob(request.data.data, "application/pdf");
            setTimeout(() => {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  filename+'-'+id
                );
              } else {
                return this.downloadClick(blob, filename+'-'+id);
              }
            }, 0);            
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1409", e);
        });      
    },
    downloadClick (blob, filename) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";      
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    downloadDoc(link) {
      this.$http
        .get("api/appfile/getassetbyid/" + link)
        .then(request => {
          if (request.status == 200) {
            var blob = this.base64toBlob(request.data.data, request.data.mimeType);
            setTimeout(() => {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  link
                );
              } else {
                return this.downloadClick(blob, link);
              }
            }, 0);            
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1410", e);
        });
    },
    base64toBlob(b64Data, contentType) {
      contentType = contentType || "";
      var sliceSize = 1024;
      var byteCharacters = atob(b64Data);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);

      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: contentType });
    },
    getRule(type, isRequired) {
      if (type == "27" || type == "39") {
        if (isRequired) return this.emailRules;
        else return this.emailOptionalRules;
      }
      else if (type == "28") {
        if (isRequired) return this.autoRules;
      }
      else if (type == "4") return this.numberOptionalRules;
      else {
        if (isRequired) return this.nameRules;
      }
    },
    getType(type) {
      if (type == "4") return "number";
      else return "text";
    },
    analyseProfile() {
      this.documentsStep = 0;
      this.documentsList = [];
      this.documentsDates = [];
      this.fieldsDates = [];
      this.documentsSelected = [];
      
      this.identity.profile.steps.forEach(step => {
        step.fields.forEach(stepField => {
          if (stepField.type == 38) {
            this.documentsExist = true;
            var type = this.documentTypes.find(x => x.id == stepField.name);
            this.documentsList.push({type: type, expirationDate: null, isValidated: null});
            this.documentsDates.push({id: stepField.id, datemenu: false, date: null, dateFormatted: "", deleteDialog: false});
          }
          else if(stepField.type == 3) {
              var fieldDate = {id: stepField.id, datemenu: false, date: null, dateFormatted: ''};
            if (stepField.value != null && stepField.value != ""){
              fieldDate.date = stepField.value;
              fieldDate.dateFormatted =this.$moment.utc(stepField.value).local().format("YYYY-MM-DD");
            }
            this.fieldsDates.push(stepField);
          }
        });
      });
      if (this.identity.person) {
        if (this.identity.person.documents && this.identity.person.documents.length > 0) {
          this.documentsExist = true;
          this.documentsStep = 1;
          this.identity.person.documents.forEach(doc => {
            var i = this.documentsList.findIndex(d => d.type.id == doc.type.id);
            this.documentsList[i] = doc;
            if (doc.expirationDate) {
              this.documentsDates[i].date = this.$moment.utc(doc.expirationDate).local().format("YYYY-MM-DD");
              this.documentsDates[i].dateFormatted = this.formatDate(this.documentsDates[i].date);
            }
          });
        }
      }
      this.setSelection();
    },
    documentsDatePicker(id) {
      this.documentsDates.find(d => d.id == id).datemenu = false;
      this.documentsDates.find(d => d.id == id).dateFormatted = this.formatDate(this.documentsDates.find(d => d.id == id).date);
    },
    fieldsDatePicker(id) {
      this.fieldsDates.find(f => f.id == id).datemenu = false;
      this.fieldsDates.find(f => f.id == id).dateFormatted = this.formatDate(this.fieldsDates.find(f => f.id == id).date);
    },
    statusNameToId(name) {
      if (this.$root.$children[0]) {
        return this.$root.$children[0].getIdentityStatusId(name);
      }
      else return "";
    },
    getNote() {
      if (this.identity.events) {
        var event = this.identity.events.find(e => e.action == "StatusUpdate" && e.modified == this.identity.modified);
        if (event && event.note)
          return event.note;
      }
      return "";
    },
  },
  mounted: function() {
    this.getOrganizationProfiles();
    this.getOrganizations();
    this.getDocumentTypes();
    this.setBirthDate();
    if (this.identity.startDate) {
      this.startDate = this.$moment
        .utc(this.identity.startDate)
        .local()
        .format("YYYY-MM-DD");
      this.startTime = this.$moment
        .utc(this.identity.startDate)
        .local()
        .format("HH:mm");
    }
    if (this.identity.endDate) {
      this.endDate = this.$moment
        .utc(this.identity.endDate)
        .local()
        .format("YYYY-MM-DD");
      this.endTime = this.$moment
        .utc(this.identity.endDate)
        .local()
        .format("HH:mm");
    }
  }
};
</script>